import React from 'react';
import Header from '../Header/Header';
import HeroSection from '../LandingPage/HeroSection'
import { useLocation } from 'react-router-dom';
import Footer from '../Footer/Footer';
const Layout = ({ homeBanner, children, title, subTitle, trip }) => {
    const location = useLocation();
    const isHome = location.pathname === "/";
    // const isAbout = location.pathname === "/about";

    return (
        <div className='main_landing'>
            <div className={`main_bg_cover ${!isHome ? 'about__height' : ''}`} style={{ background: `linear-gradient(to top, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.1) 100%), url(${isHome ? homeBanner : ""})` }}>
                <Header />
                <HeroSection trip={trip} bg={homeBanner} title={title} subTitle={subTitle} />
            </div>
            <div>
                {children}
            </div>
            <div>
                <p></p>
            </div>
            <Footer />
        </div>
    )
}

export default Layout
